import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import {GlobalDebugMode} from "@mnjsplatform/data";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";

export default (props) => {
    return <ItemInjector key={`ClaimsPD.ShowHistory_${props.rowKey.ClaimPDTypeId}`}
        dataItem={{
        controller: "PrivateDocuments",
        methodName: "ClaimsPD.ShowHistory",
        withParamset : false,
        fieldName: props.rowKey.ClaimPDTypeId
    }}><ConnectedRequestHistory {...props} /></ItemInjector>
};

class RequestHistory extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.rowKey.ClaimPDTypeId !== prevProps.rowKey.ClaimPDTypeId
            || this.props.updateStateFlag !== prevProps.updateStateFlag){
            this.initialize();
        }
    }
    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem_History.reset());
                await this.props.dispatch(this.props.dataItem_History.execute(this.props.rowKey, {
                    withParams: false,
                    withStyle: true,
                    newItem: true
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }
    renderCellEx = (cellParams) => {
        if (cellParams.fieldInfo.Name === "Comment") {
            return renderHTML(cellParams.row[cellParams.fieldInfo.Name]);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    render() {
        if (!this.state.isDataReady || this.props.dataItem_History.rowsCount() === 0)
            return null;

        return (
            <PlaceholderWrapper placeholderId={`${this.props.rowKey.ClaimPDTypeId}_HISTORY`} title={i18next.t("Request_History_1")} canCollapse={true}
                                staticTitle={`${this.props.rowKey.ClaimPDTypeName} - ${i18next.t("Request_History_1")}`}
                                showSplitterLine={false} collapsed={true}>
                <GridView dataItem={this.props.dataItem_History} useItemStyle={true} renderCellEx={this.renderCellEx}/>
            </PlaceholderWrapper>
        );
    }
}

RequestHistory.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_History: PropTypes.object,
    rowKey: PropTypes.object,
    updateStateFlag: PropTypes.any
}

RequestHistory.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_History: ownProps.getItemState(state)
    }
}

const ConnectedRequestHistory = connect(mapStateToProps)(RequestHistory);